import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

// Types
import { CheckActivationCodeValidityAndTrialMode } from '../../../shared/types/manageCalls';
import { ToFreeze } from '../../../shared/types/common';
import { StorageKey } from '../../../shared/types/storage';

// Services
import { AlertService } from '../alert/alert.service';
import { StorageService } from '../storage/storage.service';
import { TranslationService } from '../translation/translation.service';

@Injectable({ providedIn: 'root' })
export class ActivationCodeService {
  private alerts = inject(AlertService);
  private translate = inject(TranslationService);
  private storage = inject(StorageService);
  private router = inject(Router);

  public activationCode: string | null = undefined;
  public activationCodeValidity: CheckActivationCodeValidityAndTrialMode | undefined;
  public alertActivationCode: HTMLIonAlertElement = null;

  private HOME = '/home';

  async showErrorAndRemoveActivationCode(message?: string, shouldRedirectHome: boolean = true): Promise<void> {
    const translatedMessage =
      message === undefined ? this.translate.instant('COMMON.ACTIVATION_CODE_EXPIRED') : message;
    this.alertActivationCode = await this.alerts.showAlert(this.translate.instant('COMMON.CAUTION'), translatedMessage);

    this.activationCode = null;
    this.storage.removeFromStorage(StorageKey.ActivationCode).subscribe();

    this.storage.getFreezedState('ActivationCodeService 38').subscribe({
      next: (lastState: ToFreeze) => {
        lastState.activationCodeValidity = undefined;

        this.storage.setOnStorage(StorageKey.FreezeLastState, lastState).subscribe();
      },
    });

    await this.alertActivationCode?.onDidDismiss().then(() => {
      this.alertActivationCode = null;

      if (shouldRedirectHome) {
        this.navigateToMainPage();
      }
    });
  }

  private navigateToMainPage(): void {
    void this.router.navigateByUrl(this.HOME);
  }
}
